<template>
  <div>
    <div v-for="(field, i) in fields" :key="i" :class="field.class">
      <component
        v-bind:is="field.typeInput"
        v-bind="$attrs"
        :value="value ? value[i] : null"
        @input="setValue($event, i)"
      >
        <template v-for="slot in slots" v-slot:[slot]>
          <slot :name="slot" />
        </template> </component
    ></div>
  </div>
</template>

<script>
import { asyncComponent } from '../async'
import { copyByJson } from '@src/utils'
export default {
  components: {
    FieldDate: () =>
      asyncComponent(
        import(
          /* webpackChunkName: "saerch-filter-async" */ '@components/field/field-date.vue'
        )
      ),
  },
  props: {
    fields: { type: Array, required: true, default: () => [] },
    value: { default: () => [] },
  },
  data: () => ({}),
  computed: {
    slots() {
      return Object.keys(this.$scopedSlots)
    },
  },
  methods: {
    setValue(e, index) {
      const value = []
      this.fields.forEach((x, i) => {
        if (i == index) {
          value.push(e)
        } else {
          value.push(this.value ? this.value[i] : null)
        }
      })
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped></style>
